/**
 * Tap feedback for link-buttons marked [data-sm-press]: the homepage hero,
 * the Travel Edit and New & Noteworthy (motion pass, 2026-09-24). iOS
 * Safari never applies :active to a plain link, so the states are classes:
 * .is-pressed while a finger or mouse is down, .is-leaving once the link
 * is followed in this tab, held until the next page takes over and cleared
 * if the page comes back from the back/forward cache. A slideshow's
 * full-slide link presses that slide's button, which is where the eye is.
 * The look lives in sexymodest-core.css.
 *
 * Loaded as <script type="module"> by each section that uses it, so the
 * browser runs it once per page.
 */
(() => {
  const find = (target) => {
    const own = target.closest?.('[data-sm-press]');
    if (own) return own;
    const slide = target.closest?.('.hero__slide-link');
    return slide?.parentElement?.querySelector('.hero__link [data-sm-press]') || null;
  };
  const release = () => {
    for (const el of document.querySelectorAll('[data-sm-press].is-pressed')) el.classList.remove('is-pressed');
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.isPrimary) find(event.target)?.classList.add('is-pressed');
  }, { passive: true });
  for (const type of ['pointerup', 'pointercancel', 'dragstart']) {
    document.addEventListener(type, release, { passive: true });
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const el = find(event.target);
    if (!el) return;
    el.classList.add('is-leaving');
    // If the page change stalls or never happens, don't leave it held.
    setTimeout(() => el.classList.remove('is-leaving'), 5000);
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    for (const el of document.querySelectorAll('[data-sm-press].is-leaving')) el.classList.remove('is-leaving');
  });
})();
